// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/Chat/Chat.css
// module id = 1799
// module chunks = 0